import { render, staticRenderFns } from "./Ver2ScanDocument.vue?vue&type=template&id=6b7a1b11"
import script from "./Ver2ScanDocument.vue?vue&type=script&lang=js"
export * from "./Ver2ScanDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports